/**
 * The pending OAuth consent request identifier — read from and written to the
 * URL, never stored in component or context state. See state.md row 5: the
 * request id must survive a reload and be shareable, which the session
 * deliberately does not (`SessionProvider`).
 *
 * Used by `src/app/RequireSession.tsx`, the `auth` slice and the `consent`
 * slice — the reason this lives in `src/lib/` rather than inside one slice.
 */

/** ASSUMPTION — the story's open question 1. Unconfirmed with the backend track.
 *  If the backend 302s with a different parameter name, change this one constant. */
export const REQUEST_ID_PARAM = 'request_id';

/** 1–200 characters, no whitespace, no `/` — it goes into a URL path segment. */
export function isValidRequestId(value: string): boolean {
    return (
        value.length >= 1 &&
        value.length <= 200 &&
        !/\s/.test(value) &&
        !value.includes('/')
    );
}

/** Trims, validates, and returns `null` when the id is absent or invalid. */
export function readRequestId(params: URLSearchParams): string | null {
    const raw = params.get(REQUEST_ID_PARAM);
    if (raw === null) {
        return null;
    }

    const trimmed = raw.trim();
    return isValidRequestId(trimmed) ? trimmed : null;
}

export function loginPathFor(requestId: string | null): string {
    return requestId
        ? `/login?${REQUEST_ID_PARAM}=${encodeURIComponent(requestId)}`
        : '/login';
}

export function authorizePathFor(requestId: string): string {
    return `/authorize?${REQUEST_ID_PARAM}=${encodeURIComponent(requestId)}`;
}
